/* Dalafisk no-results state.

   Two jobs, both on machinery the base theme already ships.

   1. <dalafisk-recently-viewed> fills the design's "Kanske detta?" cards. The
      handles are the ones app.js:928 already keeps in localStorage under
      `recently-viewed`, and they become products exactly the way
      assets/recently-viewed-products.js does it: a `handle:a OR handle:b`
      search rendered through an alternate view, whose `.products` block is
      lifted out. Only the view differs (Dalafisk cards instead of Pinnacle's),
      so nothing of Pinnacle's own is touched.

   2. "Menade du …?" on the SEARCH PAGE. The panel gets Shopify's suggestion
      server-side — it rides along in the response predictive-search.js:77
      already asks for — but a page render has no `predictive_search` object,
      so the same endpoint is asked here and the slot filled if an answer comes.

   The panel re-renders on every keystroke, so a fresh element is constructed
   each time a search comes back empty. The markup is cached in the module: the
   visitor's history cannot change while they are typing, and without it the
   panel would refetch the same three products on every letter. */
(function () {
  'use strict';

  var cardCache = null;

  function routes() {
    return (window.theme && window.theme.routes) || {};
  }

  function recentHandles(max, skip) {
    var ids;
    try {
      ids = JSON.parse(window.localStorage.getItem('recently-viewed') || '[]');
    } catch (e) {
      return [];
    }
    if (!Array.isArray(ids)) return [];
    return ids
      .filter(function (handle) {
        return typeof handle === 'string' && handle && handle !== skip;
      })
      .slice(0, max);
  }

  function reveal(element) {
    var block = element.closest('[data-dalafisk-nohits-maybe]');
    if (block) block.hidden = false;
    /* Pinnacle's own lazy loader owns these images; the panel inserts them
       after load, when the observer has already passed them by. */
    if (window.lazySizes && window.lazySizes.loader) {
      element.querySelectorAll('.lazyload').forEach(function (image) {
        window.lazySizes.loader.unveil(image);
      });
    }
  }

  if (!customElements.get('dalafisk-recently-viewed')) {
    customElements.define(
      'dalafisk-recently-viewed',
      class DalafiskRecentlyViewed extends HTMLElement {
        connectedCallback() {
          if (this.loaded) return;
          this.loaded = true;

          var container = this.querySelector('.products');
          if (!container) return;

          if (cardCache !== null) {
            if (!cardCache) return;
            container.innerHTML = cardCache;
            reveal(container);
            return;
          }

          var handles = recentHandles(Number(this.dataset.max || 3), this.dataset.skip);
          if (!handles.length) {
            cardCache = '';
            return;
          }

          var query = handles
            .map(function (handle) {
              return 'handle:' + handle;
            })
            .join(' OR ');
          var url =
            (routes().search_url || '/search') +
            '?view=dalafisk-recently-viewed&type=product&q=' +
            encodeURIComponent(query);

          fetch(url)
            .then(function (response) {
              return response.ok ? response.text() : '';
            })
            .then(function (text) {
              if (!text) {
                cardCache = '';
                return;
              }
              var parsed = new DOMParser().parseFromString(text, 'text/html').querySelector('.products');
              var markup = parsed ? parsed.innerHTML.trim() : '';
              cardCache = markup;
              if (!markup) return;
              container.innerHTML = markup;
              reveal(container);
            })
            .catch(function () {
              cardCache = '';
            });
        }
      }
    );
  }

  /* The suggestion slot only exists on the search page; the panel renders the
     answer it already has, or nothing. */
  function fillSuggestion(state) {
    var slot = state.querySelector('[data-dalafisk-nohits-suggest]');
    if (!slot || slot.dataset.asked) return;
    slot.dataset.asked = '1';

    var terms = state.getAttribute('data-terms') || '';
    if (!terms) return;

    var endpoint = routes().predictive_search_url || '/search/suggest';
    fetch(
      endpoint +
        '.json?q=' +
        encodeURIComponent(terms) +
        '&' +
        encodeURIComponent('resources[type]') +
        '=query&' +
        encodeURIComponent('resources[limit]') +
        '=3'
    )
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        var results = data && data.resources && data.resources.results;
        var queries = (results && results.queries) || [];
        var match = null;
        for (var i = 0; i < queries.length; i++) {
          var text = queries[i] && queries[i].text;
          if (text && text.toLowerCase() !== terms.toLowerCase()) {
            match = queries[i];
            break;
          }
        }
        if (!match) return;

        var link = slot.querySelector('a');
        if (!link) return;
        link.textContent = match.text;
        link.href = match.url || (routes().search_url || '/search') + '?q=' + encodeURIComponent(match.text);
        slot.hidden = false;
      })
      .catch(function () {});
  }

  function init() {
    document.querySelectorAll('[data-dalafisk-nohits]').forEach(fillSuggestion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
